import HeadsUpDisplay from "@/components/HeadsUpDisplay";
import AgentActionsCenter from "@/components/AgentActionsCenter";
import PrioritiesSection from "@/components/PrioritiesSection";
import BrandManager from "@/components/BrandManager";
import Artifacts from "@/components/Artifacts";
import TeamLeaderboard from "@/components/TeamLeaderboard";
import { IcpHealthCard } from "@/components/onboarding/IcpHealthCard";

// Three-column command module: stream (left), agent actions (centre), ICP / priorities / brand / artifacts (right).
export const DashboardGrid = ({ userId, onRefresh, currentInstance, onOpenTargeting, stream }) => (
  <>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">
      <div className="lg:col-span-4">
        <HeadsUpDisplay userId={userId} onRefresh={onRefresh} externalUpdates={stream.updates} setExternalUpdates={stream.setUpdates}
          externalPaused={stream.paused} setExternalPaused={stream.setPaused} />
      </div>
      <div className="lg:col-span-4">
        <AgentActionsCenter userId={userId} onRefresh={onRefresh} />
      </div>
      <div className="lg:col-span-4 space-y-4">
        <IcpHealthCard userId={userId} instanceId={currentInstance?.instanceId} onOpenTargeting={onOpenTargeting} />
        <PrioritiesSection userId={userId} onRefresh={onRefresh} />
        <BrandManager userId={userId} currentInstance={currentInstance} />
        <Artifacts userId={userId} />
      </div>
    </div>
    <TeamLeaderboard />
  </>
);
